import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PATTERN_CIRCLE, PATTERN_PLUS, PATTERN_SQUARE } from './Pattern.constants';
export function getSquarePatternProps() {
  return {
    className: 'pattern pattern-square'
  };
}
export function getCirclePatternProps() {
  return {
    className: 'pattern pattern-circle'
  };
}
export function getPlusPatternProps(componentProps) {
  var backgroundColor = componentProps.backgroundColor,
    color = componentProps.color;
  return {
    className: 'pattern pattern-plus',
    style: {
      background: "linear-gradient(180deg, ".concat(backgroundColor, " 67%, transparent 0) 0 8px, linear-gradient(90deg, ").concat(color, " 8%, transparent 0) 5px 0, linear-gradient(90deg, ").concat(backgroundColor, " 67%, transparent 0) 8px 0, linear-gradient(180deg, ").concat(color, " 8%, ").concat(backgroundColor, " 0) 5px 5px"),
      backgroundSize: "calc(15px) calc(15px)"
    }
  };
}
export function getUnknownPatternProps() {
  return {
    className: 'unknown-type'
  };
}
export function patternPropsGetter(pattern) {
  var _patternToGetter;
  var patternToGetter = (_patternToGetter = {}, _defineProperty(_patternToGetter, PATTERN_CIRCLE, getCirclePatternProps), _defineProperty(_patternToGetter, PATTERN_PLUS, getPlusPatternProps), _defineProperty(_patternToGetter, PATTERN_SQUARE, getSquarePatternProps), _patternToGetter);
  return patternToGetter[pattern] || getUnknownPatternProps;
}